import { useEffect, useState } from 'react';

/**
 * Use this hook to keep track of the value of something that may change more rapidly than
 * you can to act on, so you can wait until the value has settled.
 *
 * @param value Whatever value you are tracking.
 * @param delay The number of milliseconds to wait.
 */

export function useDebouncedValue<T>(value: T, delay: number): T {
  // Most recent value to use
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      // Set debouncedValue to value (passed in) after the specified delay
      const timerId = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return (): void => {
        clearTimeout(timerId);
      };
    },
    // Only re-call effect if value changes or time has been reached
    [value, delay],
  );

  return debouncedValue;
}
